/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCommentDto
 */
export interface UpdateCommentDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCommentDto
     */
    message: string;
}

/**
 * Check if a given object implements the UpdateCommentDto interface.
 */
export function instanceOfUpdateCommentDto(value: object): value is UpdateCommentDto {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function UpdateCommentDtoFromJSON(json: any): UpdateCommentDto {
    return UpdateCommentDtoFromJSONTyped(json, false);
}

export function UpdateCommentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCommentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function UpdateCommentDtoToJSON(value?: UpdateCommentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'message': value['message'],
    };
}

